import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';
const { baseUrl } = environment;

const apiMap: Record<string, string> = {
  '@api': baseUrl,
  // '@auth': 'https://auth.blackcat.io',
  // '@events': 'https://events.api.blackcat.io',
  // '@analytics': 'https://metrics.blackcat.io'
};


export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const isAbsolute = req.url.startsWith('http');
  const shouldBypass =
    req.url.startsWith('i18n/') ||
    req.url.startsWith('images/') ||
    req.url.startsWith('favicon') ||
    req.url.endsWith('.json');

  let updatedReq = req;

  if (!isAbsolute && !shouldBypass) {
    const hasPrefix = Object.keys(apiMap).some(key => req.url.startsWith(key));
    const finalUrl = hasPrefix ? req.url : `@api/${req.url}`;
    const prefix = Object.keys(apiMap).find(key => finalUrl.startsWith(key));
    if (prefix) {
      const base = apiMap[prefix];
      const path = finalUrl.replace(`${prefix}/`, '');
      updatedReq = req.clone({ url: `${base}/${path}` });
    }
  }
  return next(updatedReq);
};
